import { gql } from '@apollo/client';

const PatientInfoPublic = gql`
  fragment PatientInfoPublic on Patient {
    id
    firstName
    lastName
    dob
    birthDay
    birthMonth
    birthYear
    arches
    retainerBank
    hasPlan
    hasFreeTrial
    hasPendingOrderWithoutProductionOrder
    hasUnshippedProductionOrder
    planStartAt
    partnerOrganizationId
    partnerLocationId
    settingGroupOptionIds
    settingsOverride
    scanReady
    scanReadyAt
    scanSentAt
    partnerUploadScanAt
    notes
    sendToClinic
    consumedSendToClinic
    includeEot
    legacyId
    scheduledShipments {
      id
      consumed
      shippedAt
      expectedShippedAt
      broughtForward
    }
    orders {
      id
      hexCode
      createdAt
      total
      state
    }
    createdAt
    updatedAt
  }
`;

export default PatientInfoPublic;
